import { get } from "lodash";
import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Field } from "formik";
import { Form } from "semantic-ui-react";

import FormikSemanticInput from "../forms/formik/FormikSemanticInput.jsx";
import FormikSemanticTextArea from "../forms/formik/FormikSemanticTextArea.jsx";
import FormikSemanticDropdown from "../forms/formik/FormikSemanticDropdown.jsx";

import {
  selectImageId,
  selectImage,
  selectSize
} from "../../state/reducers/projectWizard/projectWizardSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class VPNDetailsForm extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    volumes: PropTypes.array.isRequired,
    apiErrors: PropTypes.object,
    copyKey: PropTypes.string.isRequired,

    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function

    selectedImageId: PropTypes.string,
    selectedImage: PropTypes.object,
    selectedSize: PropTypes.object,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "vpns"
  };

  componentDidUpdate(prevProps) {
    const { id, formikProps, selectedImageId, volumes } = this.props;

    if (prevProps.selectedImageId !== selectedImageId) {
      // set default volume size for selected image
      volumes.forEach(volume => {
        const { name } = volume;
        const fieldName = name ? `${id}.${name}VolumeSize` : `${id}.volumeSize`;
        const fieldValue = get(volume, "size.suggested", 0);
        formikProps.setFieldValue(fieldName, fieldValue);
      });
    }
  }

  // -- RENDER -- //

  renderSiteInputs = () => {
    const { id, selectedImageId, readOnly, apiErrors, copyKey, copy } =
      this.props;

    // -- START - nasty WIRE GUARD HACK -- //
    // also adds image to props const above
    if (
      selectedImageId === "/images/CbJ2JZr7-vRiH-je6x-rZcn-f0gUnialAGyg" || // AWS
      selectedImageId === "/images/e4b95dbe-acdd-4fd8-894c-79d9f439538f" || // AWS 2
      selectedImageId === "/images/7721a7ac-c82a-4293-893a-bc5639e8b231" || // AWS 3
      selectedImageId === "/images/28afc343-94e9-45ae-93a8-bf41812df813" || // AWS - 18.2.7
      selectedImageId === "/images/40c9d930-6af0-45c3-815d-027f1d258dea" || // AWS - Rocky 8.9
      selectedImageId === "/images/370947af-9765-4fcb-93e2-5b273ecfc01b" || // AWS
      selectedImageId === "/images/797330f3-32a5-435f-ab8f-4d20769eaaae" || // GCP - Centos
      selectedImageId === "/images/1467bcb0-e07c-4f65-98f9-e6717b806b17" || // GCP - Rocky
      selectedImageId === "/images/d46cb380-8132-47d6-8fd3-22c552787484" || // GCP 3 - Rocky 8.8
      selectedImageId === "/images/4fcafdaa-2d43-4de1-ad9b-76ecc57ca84f" || // GCP - 18.2.7
      selectedImageId === "/images/392617f9-9bf8-477e-a88f-7578b3d4effd" || // GCP - Rocky 8.9
      selectedImageId === "/images/2361024d-5d44-438e-a012-901a49829305" || // GCP
      selectedImageId === "/images/d8e495ad-67d2-467c-8b8a-443f98d63157" || // Azure - Rocky 8.8
      selectedImageId === "/images/9035b74a-c577-4c75-baf0-a0b639a1d03f" // Azure
    ) {
      return null;
    }
    // -- END - nasty WIRE GUARD HACK -- //

    return (
      <Form.Group widths="equal">
        <Field
          name={`${id}.sitePublicIP`}
          label={copy(`${copyKey}.public_ip_label`)}
          placeholder={copy(`${copyKey}.public_ip_placeholder`)}
          readOnly={readOnly}
          required={true}
          apiErrors={apiErrors}
          component={FormikSemanticInput}
        />
        <Field
          name={`${id}.siteSubnet`}
          label={copy(`${copyKey}.subnet_label`)}
          placeholder={copy(`${copyKey}.subnet_placeholder`)}
          readOnly={readOnly}
          required={true}
          apiErrors={apiErrors}
          component={FormikSemanticInput}
        />
      </Form.Group>
    );
  };

  render() {
    const {
      id,
      selectedImage,
      selectedSize,
      imagesList,
      sizesList,
      readOnly,
      apiErrors,
      copyKey,
      copy
    } = this.props;

    return (
      <Fragment>
        <Field
          name={`${id}.name`}
          label={copy(`${copyKey}.name_label`)}
          placeholder={copy(`${copyKey}.name_placeholder`)}
          autoFocus={true}
          readOnly={readOnly}
          required={true}
          apiErrors={apiErrors}
          component={FormikSemanticInput}
        />
        <Field
          name={`${id}.description`}
          label={copy(`${copyKey}.description_label`)}
          placeholder={copy(`${copyKey}.description_placeholder`)}
          readOnly={readOnly}
          required={false}
          apiErrors={apiErrors}
          component={FormikSemanticTextArea}
        />
        <Form.Group widths="equal">
          <Field
            name={`${id}.image`}
            label={copy(`${copyKey}.image_placeholder`)}
            className="image-icon-dropdown"
            help={selectedImage.description}
            placeholder={copy(`${copyKey}.image_label`)}
            options={imagesList}
            required={true}
            apiErrors={apiErrors}
            component={FormikSemanticDropdown}
          />
          <Field
            name={`${id}.size`}
            label={copy(`${copyKey}.size_placeholder`)}
            help={selectedSize.description}
            placeholder={copy(`${copyKey}.size_label`)}
            options={sizesList}
            required={true}
            apiErrors={apiErrors}
            component={FormikSemanticDropdown}
          />
        </Form.Group>

        {this.renderSiteInputs()}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  selectedImageId: selectImageId(state, props),
  selectedImage: selectImage(state, props),
  selectedSize: selectSize(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(VPNDetailsForm);
